export default __webpack_public_path__ + "static/media/app-2.cf35b5c7.png";